const BASE_URL = "https://api.eternaltattoo.trangotechdevs.com";

const API_URL = `${BASE_URL}/api/admin/`;

const AGENT_API_URL = `${BASE_URL}/api/agent/`;

const INITIAL_TOKEN =
  process.env.REACT_APP_SERVICE_TOKEN ||
  "76fa361a23c40444a3762a1aa552955d";

const SOCKET_BASE_URL =  BASE_URL;
const SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH || "/socket.io";

export {
  AGENT_API_URL,
  API_URL,
  BASE_URL,
  INITIAL_TOKEN,
  SOCKET_BASE_URL,
  SOCKET_PATH,
};
